import {
  INCIDENT_ACTION_STATUS_LABELS,
  INCIDENT_STATUS_LABELS,
  type IncidentActionStatus,
  type IncidentStatus,
} from '@wodi/domain';
import { Tag } from '@wodi/ui';

// Incident states as words on tags (DESIGN.md §7): the shape and the word carry the state;
// severity is words only, never the danger colour (danger is for clinical danger on screen).

const STATUS_TAG = {
  reported: 'pending',
  under_review: 'active',
  actions: 'attention',
  closed: 'done',
  entered_in_error: 'neutral',
} as const satisfies Record<IncidentStatus, string>;

export function IncidentStatusTag({ status }: { status: IncidentStatus }) {
  return <Tag state={STATUS_TAG[status]}>{INCIDENT_STATUS_LABELS[status]}</Tag>;
}

export function ActionStatusTag({
  status,
  overdue,
}: {
  status: IncidentActionStatus;
  overdue: boolean;
}) {
  if (overdue) return <Tag state="attention">Overdue</Tag>;
  return (
    <Tag state={status === 'done' ? 'done' : status === 'open' ? 'pending' : 'neutral'}>
      {INCIDENT_ACTION_STATUS_LABELS[status]}
    </Tag>
  );
}
